import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 18"
      className="design-iconfont"
    >
      <path d="M11.428 9.49A10.49 10.49 0 0 1 3 5.267c.894 3.836 4.334 6.701 8.428 6.701.53 0 .957.444.957.992v1.907L17 10.728l-4.615-4.176v1.946c0 .548-.428.992-.957.992M2.212 1c.436 0 .817.296.92.718.844 3.434 3.81 5.915 7.385 6.29V6.955c0-.665.397-1.257 1.036-1.544.692-.313 1.5-.2 2.062.286l4.8 4.164c.372.324.585.782.585 1.257 0 .476-.213.934-.585 1.258l-4.8 4.163c-.562.487-1.37.6-2.062.287-.639-.288-1.036-.88-1.036-1.544v-1.146C5.19 13.67 1 9.329 1 4.059c0-.763.099-1.55.292-2.34A.943.943 0 0 1 2.212 1" />
    </svg>
  )
}
const ImporterIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
ImporterIcon.defaultProps = {
  width: 20,
  height: 20,
  fill: 'rgb(var(--ow-primary-color))',
}
// 参数类型
ImporterIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default ImporterIcon
